import './App.css';
import { useState } from 'react';
import Accordion from './Accordion';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';


function Template() {
const [button2, setbutton2] = useState('Insight')

let navigate = useNavigate();

    const goToContact = () => {navigate('/contact');};
    const goToTemplate = () => {navigate('/template');};
    const goToPricing = () => {navigate('/pricing');};
    const navigateToExternalUrl = () => {window.location.href = "https://api.walletly.ai/signup";};
    const navigateToExternalUrl1 = () => {window.location.href = "https://api.walletly.ai";};

  const REF = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={44}
      height={44}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#E8EDF9"
          d="M44 22C44 9.85 34.15 0 22 0S0 9.85 0 22s9.85 22 22 22 22-9.85 22-22"
        />
        <mask
          id="b"
          width={25}
          height={25}
          x={10}
          y={9}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path fill="#fff" d="M10.02 9.999h24v24h-24z" />
        </mask>
        <g fill="#627AFE" mask="url(#b)">
          <path d="M22.012 19.9a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
          <path d="M14.708 34c-.3 0-.5-.1-.8-.2-.6-.3-.9-.9-.9-1.6v-3.6c0-1.3.4-2.3 1.1-3l2-2.1c-.1-1.1-.1-2.3-.1-3.5 0-7.8 5.4-9.8 5.7-9.9l.3-.1.3.1c.2.1 5.7 2 5.7 9.9 0 1.2 0 2.4-.1 3.5l2 2.1c.7.7 1.1 1.7 1.1 3v3.6c0 .7-.3 1.2-.8 1.5-.6.3-1.2.3-1.8-.1l-2.4-1.8-1.4 2.1h-5.1l-1.4-2-2.4 1.8c-.3.19-.646.293-1 .3m5.8-2.1h2.9l.7-1h-4.3zm1.5-19.8c-1 .5-4 2.4-4 7.8 0 1.3.1 2.6.2 3.8v.5l-2.7 2.8c-.4.4-.5.9-.5 1.6v3.1l2.3-1.8c.2-.1.3-.2.4-.2.5-.4 1.2-.8 2-.8h4.6c.9 0 1.6.5 2.2.9l.2.1 2.3 1.7v-3c0-.7-.2-1.2-.5-1.6l-2.7-2.8v-.5c.1-1.2.2-2.5.2-3.8 0-5.4-3-7.3-4-7.8" />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h44v44H0z" />
        </clipPath>
      </defs>
    </svg>
  );
  const REF1 = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <path
            fill="#E8EDF9"
            d="M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16"
          />
          <path
            fill="#627AFE"
            stroke="#627AFE"
            strokeWidth={0.339}
            d="M13.903 20.497h-.131l-.033.127a2.5 2.5 0 0 1-2.409 1.873 2.497 2.497 0 0 1 0-4.995q.343.006.67.104l.129.038.067-.115 2.072-3.553.066-.114-.093-.092a2.497 2.497 0 1 1 3.515 0l-.094.092.067.114 2.076 3.551.067.114.127-.037a2.526 2.526 0 1 1-1.742 3.022l-.032-.129h-4.323Zm1.424-6.104-.127-.038-.067.115-2.072 3.552-.066.113.092.092c.316.317.541.714.652 1.148l.032.127h4.452l.033-.127c.111-.436.338-.834.657-1.152l.093-.092-.066-.114-2.075-3.548-.067-.115-.128.038a2.4 2.4 0 0 1-.673.105 2.5 2.5 0 0 1-.67-.104ZM21.5 18.75a1.503 1.503 0 1 0-1.67 2.499 1.503 1.503 0 0 0 1.67-2.499Zm-4.667-8a1.503 1.503 0 1 0-1.67 2.499 1.503 1.503 0 0 0 1.67-2.499Zm-4.666 8a1.503 1.503 0 1 0-1.67 2.5 1.503 1.503 0 0 0 1.67-2.5Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );

  const A = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={38}
      height={38}
      fill="none"
      {...props}
    >
      <rect width={38} height={38} fill="#E8EDF9" rx={19} />
      <path
        stroke="#627AFE"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m13.75 15.25-.914.61c-.655.436-.983.655-1.16.988-.178.333-.177.725-.174 1.508.003.942.012 1.903.036 2.875.058 2.305.087 3.458.934 4.306s2.017.877 4.354.936a87 87 0 0 0 4.349 0c2.337-.059 3.505-.088 4.353-.936s.877-2 .934-4.306c.025-.972.033-1.933.037-2.876.002-.782.003-1.174-.174-1.507-.178-.333-.505-.552-1.16-.989l-.915-.609"
      />
      <path
        stroke="#627AFE"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m11.5 17.5 5.185 3.11c1.128.678 1.692 1.016 2.315 1.016s1.187-.338 2.315-1.015L26.5 17.5"
      />
      <path
        stroke="#627AFE"
        strokeWidth={1.5}
        d="M13.75 19v-4.5c0-1.414 0-2.121.44-2.56.439-.44 1.146-.44 2.56-.44h4.5c1.414 0 2.121 0 2.56.44.44.439.44 1.146.44 2.56V19"
      />
      <path
        stroke="#627AFE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M17.5 17.5h3m-3-3h3"
      />
    </svg>
  );

  const Linkedin = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={18}
      fill="none"
      {...props}
    >
      <mask
        id="a"
        width={18}
        height={18}
        x={1}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M1 0h18v18H1z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          fillOpacity={0.6}
          d="M17.661 0H2.328C1.596 0 1 .585 1 1.294v15.401C1 17.415 1.596 18 2.328 18H17.66c.731 0 1.328-.585 1.328-1.294V1.294C18.989.574 18.392 0 17.66 0M6.344 15.334H3.678V6.739h2.666zM5.005 5.58a1.553 1.553 0 0 1-1.552-1.541c0-.844.697-1.541 1.552-1.541s1.541.697 1.541 1.54A1.55 1.55 0 0 1 5.005 5.58m11.329 9.754h-2.666V11.16c0-.99-.023-2.273-1.384-2.273-1.362 0-1.598 1.092-1.598 2.205v4.242H8.02V6.739h2.554v1.17h.034c.36-.675 1.226-1.384 2.52-1.384 2.7 0 3.206 1.777 3.206 4.095z"
        />
      </g>
    </svg>
  );
  const FB = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        fillOpacity={0.6}
        d="M17.998 8.999a8.999 8.999 0 1 0-10.405 8.89V11.6H5.308V8.999h2.285V7.016c0-2.255 1.344-3.501 3.399-3.501.985 0 2.015.176 2.015.176v2.215h-1.135c-1.118 0-1.467.694-1.467 1.405v1.688h2.496l-.399 2.601h-2.097v6.289a9 9 0 0 0 7.593-8.89"
      />
    </svg>
  );
  const Youtube = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        fillOpacity={0.6}
        d="M9 2.07C.155 2.07 0 2.857 0 9s.155 6.93 9 6.93 9-.787 9-6.93-.155-6.93-9-6.93m2.884 7.231-4.041 1.886c-.354.164-.644-.02-.644-.41V7.224c0-.39.29-.574.644-.41L11.884 8.7c.354.166.354.436 0 .601"
      />
    </svg>
  );

  return (
    <div>

      <Header />

    <div className='container container1'>

      <div className='text2 mt-130'>Engage Customers with<br/> Ready-to-Use Email Templates</div>
      <div className='text3 mt-30 mb-85'>Discover Walletly’s tailored email templates, crafted to connect with your customers at key moments. From<br/> welcome emails to birthday rewards, each template is ready to drive engagement based on actions.</div>

      <div className='section1 parent-div justify-self-center'>
        <REF/>
        <div className='text9'>Welcome Email Template</div>
        <div className='text6'>This email is triggered when a customer signs up for the loyalty program. It guides the<br/> customers and explains how they can start earning and benefiting from it.</div>
        <img loading="lazy" className='ml--35 w-1110' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/7f127ba7-52bf-4716-1ccd-56f2f91f6d00/walletly' />
      </div>

      <div className='d-flex parent gap-24 mt-30 justify-content-center mobOne mob-align-center'>
        <img loading="lazy" className='child z-1' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/47a1ea5a-9f04-4939-957e-2a471cd6f100/walletly' />
        <div className='sec1template' style={{height: 'inherit', position: 'relative'}}>
          <div className='sec1img'><A/></div>
          <div className='sec1text1'>Birthday Email Template</div>
          <div className='sec1text222 pr-30'>Triggered on the 1st day of the customer’s birthday month, this email celebrates their birthday and offers them special rewards or points.</div>
          <div><img loading="lazy" style={{position: 'absolute', bottom: '0px'}} className='w-100 pl-30' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/efcfb0e2-a44c-4c74-13dc-681e258ebd00/walletly' /></div>
        </div>
        <div className='sec1template'>
          <div className='sec1img'><A/></div>
          <div className='sec1text1'>Transactional Email Template</div>
          <div className='sec1text222 pr-30'>This email notifies the customer of updates in their points balance from activities like placing an order, making a referral, or earning birthday points</div>
          <div><img loading="lazy" className='w-100 pl-30' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/671610fe-b4d3-448a-ce71-2979fb515200/walletly' /></div>
        </div>
      </div>

      <div className='newBox1 mobOne'>
        <div>
          <div><A/></div>
          <div className='newBox1Head'>Miss You Email Template</div>
          <div className='newBox1Text mb-26'>Triggered after a set period of inactivity, this email is designed to re-engage customers by encouraging them to return, often with incentives or reminders about their points.</div>
        </div>
        <div className='mt-auto'>
          <img loading="lazy" className='w-100' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/b9b0291f-25b9-42e9-5496-d577645bb500/walletly' />
          </div>
      </div>
      <div className='d-flex parent gap-24 mt-30 justify-content-center mobOne mob-align-center'>
        <div className='sec1template' style={{height: 'inherit'}}>
          <div className='sec1img'><A/></div>
          <div className='sec1text1'>Promotional Email Template</div>
          <div className='sec1text222 pr-30'>This email is triggered one day before a scheduled promotion, reminding customers of the upcoming offer and encouraging them to participate.</div>
          <div><img loading="lazy" className='w-100 pl-30' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/230b1958-3d43-4361-e63d-913f6900bb00/walletly' /></div>
        </div>
        <div className='sec1template'>
          <div className='sec1img'><A/></div>
          <div className='sec1text1'>Refferal Email Template</div>
          <div className='sec1text222 pr-30'>Sent one week after a customer signs up, this email encourages them to refer friends to the loyalty program by highlighting the benefits of referrals.</div>
          <div><img loading="lazy" className='w-100 pl-30' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/84067812-3f01-4503-89c9-5e197de48b00/walletly' /></div>
        </div>
      </div>

      <div className='newBox11 mobOne'>
        <div>
          <div><A/></div>
          <div className='newBox1Head'>REDEEM Email Template</div>
          <div className='newBox1Text mb-26'>Triggered when a customer is close to redeeming their points, this email serves as a reminder for them to use their points before they expire, motivating them to take action.</div>
        </div>
        <div className='mt-auto'><img loading="lazy" className='w-100' src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/dbf79f57-1ad8-4a3c-5341-4acfe9a65200/walletly' /></div>
      </div>

      
      <div className='justify-self-center mt-170 mb-25'><img loading="lazy" src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/e58b7ed5-8489-4c71-91fc-07cc5ec62500/Digi' /></div>
      
      <div className='text5 text-align-center'>Try Walletly for free</div>
      <div className='text6 mt-10 mb-24 text-align-center'>When your bank account powers your critical financial<br/>
      workflows, you’re already in the flow.</div>
      <div className='button1 ms-3 w-fit justify-self-center mb-mob-80'>Get Started</div>

      <Footer />

      
    </div>
    </div>
  );
}

export default Template;
